import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	searchContainer: {
		marginTop: '0px',
		position: 'absolute',
		left: '30%',
		top: '0px',
		zIndex: 0,
	},
	countryDropDown: {
		'& .MuiTextField-root': {
			width: '180px',
			marginRight: '20px',
			backgroundColor: '#fff',
			borderRadius: '3px',
		},
		padding: '10px',
	},
	rowAlign: {
		width: '600px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}));

export { useStyles };
